// yadsRescheduleReducer.js
import {
  RESCHEDULE_YADS_REQUEST,
  RESCHEDULE_YADS_SUCCESS,
  RESCHEDULE_YADS_FAILURE,
  RESCHEDULE_YADS_RESET,
} from '../../../Constants/actionTypes';

const initialReschedule = {
  loading: false,
  result: null,
  error: '',
};

const yadsRescheduleReducer = (state = initialReschedule, action) => {
  switch (action.type) {
    case RESCHEDULE_YADS_REQUEST:
      return { ...state, loading: true, error: '' };
    case RESCHEDULE_YADS_SUCCESS:
      return { loading: false, result: action.payload, error: '' };
    case RESCHEDULE_YADS_FAILURE:
      return { loading: false, result: null, error: action.payload };
    case RESCHEDULE_YADS_RESET:
      return initialReschedule;
    default:
      return state;
  }
};

export default yadsRescheduleReducer;
